import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { useAuth } from 'react-oidc-context'
import { Uploader } from './Components/Uploader'
import { Navbar } from './Components/Navbar'
import { useEffect } from 'react'
import { AgolExperience } from './Components/AGOL'
import { ComingSoon } from './Components/ComingSoon'

const BETA_GROUP = 'Beta'

function App() {
  const auth = useAuth()

  // Clean up OAuth code from URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (auth.isAuthenticated) {
      if (params.has('code') || params.has('state')) {
        window.history.replaceState({}, document.title, window.location.pathname)
      }
    } else {
      if (params.has('logout_uri')) {
        window.history.replaceState({}, document.title, window.location.pathname)
      }
    }
  }, [auth.isAuthenticated])

  // Handle auth states
  if (auth.isLoading) {
    return <div>Loading...</div>
  }

  if (auth.error) {
    return <div>Error: {auth.error.message}</div>
  }

  // Not authenticated - show login
  if (!auth.isAuthenticated) {
    auth.signinRedirect()
    return null
  }

  const username = auth.user?.profile?.['cognito:username'] as string
  const groups = auth.user?.profile?.['cognito:groups'] as string[] | undefined
  const isBeta = groups?.includes(BETA_GROUP) ?? false

  // Authenticated - beta
  if (isBeta) {
    return (
      <BrowserRouter>
        <Navbar showLinks={true} />
        <Routes>
          <Route index element={<Navigate to="/map" replace />} />
          <Route path="map" element={<AgolExperience username={username} useOfficial={true} />} />
          <Route
            path="mymap"
            element={<AgolExperience username={username} useOfficial={false} />}
          />
          <Route path="uploader" element={<Uploader username={username} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    )
  } else {
    return (
      <BrowserRouter>
        <Navbar showLinks={false} />
        <Routes>
          <Route path="*" element={<ComingSoon />} />
        </Routes>
      </BrowserRouter>
    )
  }
}

export default App
